import { ReactNode } from "react";
import { FormItem, InputNumber, InputNumberProps } from "melco-ui";
import { useField } from "formik";

type InputNumberFieldProps = {
    name: string;
    label?: string;
    info?: ReactNode;
};

const InputNumberField = (props: InputNumberFieldProps & InputNumberProps) => {
    const { name, label, info, ...inputNumberProps } = props;
    const [field, meta, helpers] = useField<number | undefined>(name!);

    const hasFeedback = !!(meta.touched && meta.error);
    const help = meta.touched && meta.error;
    const validateStatus = meta.touched && meta.error ? "error" : undefined;

    return (
        <FormItem
            help={hasFeedback ? help : undefined}
            validateStatus={validateStatus}
            label={label}
            info={info} //  AntD's way to show info below the input
        >
            <InputNumber
                {...inputNumberProps}
                {...field}
                value={field.value ?? null} //  Ensure value is never undefined
                onChange={(value) => {
                    //  Ensure only number or undefined is passed to Formik
                    if (typeof value === "number") {
                        helpers.setValue(value);
                    } else {
                        helpers.setValue(undefined);
                    }
                }}
                onBlur={() => helpers.setTouched(true)}
            />
        </FormItem>
    );
};

export { InputNumberField };